(function () {
    'use strict';

    angular
        .module('rms.common')
        .constant('FILTER_STEP_CONSTANT', {
            'LIST': 1,
            'PROPERTY': 2,
            'VALUES': 3
        });
})();